export function iOSPushPermissionRequest() {
    window.webkit?.messageHandlers['push-permission-request']?.postMessage('push-permission-request');
}

export function getIOSPushToken() {
    window.webkit?.messageHandlers['push-token']?.postMessage('push-token');
}

export function iOSPushCapability() {
    const handlers = window.webkit?.messageHandlers;
    return handlers?.['push-permission-request'] && handlers?.['push-permission-state'];
}

export function getIOSPushPermissionState() {
    window.webkit?.messageHandlers['push-permission-state']?.postMessage('push-permission-state');
}

export function requestIOSAppReview() {
    window.webkit?.messageHandlers['request-review']?.postMessage('request-review');
}